import {useEffect, useRef} from 'react';
import {useLocation, useNavigate, useNavigationType} from 'react-router-dom';
import {getSiteTypeFromHostname} from '../networking/Hosts';

// Only a return from an active conversation should open the exit form.
// Saved conversations must never redirect a fresh visit to the home page.
export default function AppointmentExitRedirect() {
    const location = useLocation();
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const previousPath = useRef(location.pathname);
    const siteType = getSiteTypeFromHostname();

    useEffect(() => {
        const fromConversation = /^\/chat(?:\/|$)/.test(previousPath.current);
        previousPath.current = location.pathname;
        if ((siteType === 'vax' || siteType === 'rsv') && fromConversation &&
            location.pathname === '/' && navigationType === 'POP') {
            navigate(`/reservation${location.search}`, {replace: true});
        }
    }, [location.pathname, location.search, navigationType, navigate, siteType]);

    return null;
}
